"use strict";
exports.__esModule = true;
exports.LIB_VERSION = "1.2.1-prerelease.2";
//# sourceMappingURL=Version.js.map